import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#e22c82',
        secondary: '#50c7eb',
        background: '#fff',
      },
      dark: {
        primary: '#55A678',
        background: '#222',
      },
    },
  },
});
